export const USER_SERVICE = "/user/";
export const BRAND_NAME = "🧮 TyGrid";
export const BRAND_URL = "https://tygrid.com/";
export const EXPLORER_TOOL_NAME="TyGrid OData Explorer";
export const EMAIL_ADDRESS="feedback@tygrid.com";
export const PROXY = "/proxy";